import React, { useEffect, useRef, useState } from 'react'
import './ProjectDescriptions.css'
import { timeAgo } from '../../../utils/timeAgo'

function ProjectDescriptions({ descriptions = {} }) {
  const carouselRef = useRef(null)
  const [expandedDescriptions, setExpandedDescriptions] = useState({})

  useEffect(() => {
    const carouselWrapper = document.querySelector('.cardsWrapperDescription');
    const prevButton = document.querySelector('.carousel-control.prev');
    const nextButton = document.querySelector('.carousel-control.next');

    if (!carouselWrapper || !prevButton || !nextButton) {
        // console.error('Carousel elements not found!');
        return; // Exit if essential elements are missing
    }

    const cards = carouselWrapper.querySelectorAll('.cardDescriptionWrapper');
    if (cards.length === 0) return; // No cards to slide

    const cardStyle = window.getComputedStyle(cards[0]);
    const cardWidth = cards[0].offsetWidth;
    const cardMarginRight = parseFloat(cardStyle.marginRight) || 0;
    const gap = parseFloat(window.getComputedStyle(carouselWrapper).gap) || 0; 
    // Scroll amount can be based on the width of one card plus its gap.
    // If all cards are visible, controls might not be needed or should be hidden.
    const scrollAmount = cardWidth + gap; 

    function updateControls() {
        const maxScrollLeft = carouselWrapper.scrollWidth - carouselWrapper.clientWidth;
        // A small tolerance to handle floating point inaccuracies
        const tolerance = 5; 

        if (carouselWrapper.scrollLeft <= tolerance) {
            prevButton.classList.add('hidden');
        } else {
            prevButton.classList.remove('hidden');
        }

        if (carouselWrapper.scrollLeft >= maxScrollLeft - tolerance) {
            nextButton.classList.add('hidden');
        } else {
            nextButton.classList.remove('hidden');
        }
        
        // Hide controls if all items are visible
        if (carouselWrapper.scrollWidth <= carouselWrapper.clientWidth) {
            prevButton.classList.add('hidden');
            nextButton.classList.add('hidden');
        }
    }

    prevButton.addEventListener('click', function() {
        carouselWrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextButton.addEventListener('click', function() {
        carouselWrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    // Update controls on scroll (e.g., if user scrolls manually via touch)
    carouselWrapper.addEventListener('scroll', updateControls);
    // Update controls on window resize
    window.addEventListener('resize', updateControls);

    // Initial check for controls state
    updateControls();
  }, [descriptions])


  useEffect(() => {
    const userActivities = document.querySelectorAll('.userActivity')
    userActivities.forEach(activity => {
      const userUploadSpan = activity.querySelector('.userUpload')
      const avatarSpan = activity.querySelector('.avatarDescriptionCategory span')
      
      if (userUploadSpan && avatarSpan) {
        const userName = userUploadSpan.textContent.trim()
        if (userName.length > 0) {
          avatarSpan.textContent = userName.charAt(0).toUpperCase()
        }
      }
    })
  }, [descriptions])

  const handleReadMore = (index) => {
    setExpandedDescriptions(prev => ({
      ...prev,
      [index]: !prev[index]
    }))
  }

  return (
    <div className="resultsWrapper">
      <div className="header">
        <button>
          Descriptions ({Object.keys(descriptions).length})
        </button>
      </div>
      
      <div className="descriptionWrapper" ref={carouselRef}>
        <button className="carousel-control prev" aria-label="Previous">&lt;</button>
        <div className="cardsWrapperDescription">
          {Object.values(descriptions).map((description) => (
            <div key={description.description_id} className="cardDescriptionWrapper">
              <div className="userActivity">
                <div className="avatarDescriptionCategory">
                  <span></span>
                </div>
                <span className="userUpload">{description.author}</span>
              </div>
              <div className="descriptionId">Description {description.description_id}</div>


              <div className="containerCard">
                <h2 className="cardTitle">{description.title}</h2>
                <p className={`cardDescription ${expandedDescriptions[description.description_id] ? 'expanded' : ''}`}>
                  {description.content}
                </p>

                <button 
                  className="readMoreBtnDescription"
                  onClick={() => handleReadMore(description.description_id)}
                >
                  {expandedDescriptions[description.description_id] ? 'Read Less' : 'Read More'}
                </button>

                <div className="timeStamp">{timeAgo(description.date_created)}</div>
              </div>
            </div>
          ))}
        </div>
        <button className="carousel-control next" aria-label="Next">&gt;</button>
      </div>
    </div>
  )
}

export default ProjectDescriptions 